import { v4 as uuidv4 } from 'uuid';

const fontWeight = [
    // {
    //     idSoft: uuidv4(),
    //     name: 'Black',
    //     value: 1,
    // },
    {
        idSoft: uuidv4(),
        name: 'Bold',
        cssName: 'bold',
        value: 2,
    },
    // {
    //     idSoft: uuidv4(),
    //     name: 'DemiBold',
    //     value: 3,
    // },
    // {
    //     idSoft: uuidv4(),
    //     name: 'ExtraBlack',
    //     value: 4,
    // },
    // {
    //     idSoft: uuidv4(),
    //     name: 'ExtraBold',
    //     value: 5,
    // },
    // {
    //     idSoft: uuidv4(),
    //     name: 'ExtraLight',
    //     value: 6,
    // },
    // {
    //     idSoft: uuidv4(),
    //     name: 'Heavy',
    //     value: 7,
    // },
    {
        idSoft: uuidv4(),
        name: 'Light',
        cssName: 'lighter',
        value: 8,
    },
    // {
    //     idSoft: uuidv4(),
    //     name: 'Medium',
    //     value: 9,
    // },
    {
        idSoft: uuidv4(),
        name: 'Normal',
        cssName: 'normal',
        value: 10,
    },
    // {
    //     idSoft: uuidv4(),
    //     name: 'Regular',
    //     value: 11,
    // },
    // {
    //     idSoft: uuidv4(),
    //     name: 'SemiBold',
    //     value: 12,
    // },
    // {
    //     idSoft: uuidv4(),
    //     name: 'Thin',
    //     cssName: 'thin',
    //     value: 13,
    // },
    // {
    //     idSoft: uuidv4(),
    //     name: 'UltraBlack',
    //     value: 14,
    // },
    // {
    //     idSoft: uuidv4(),
    //     name: 'UltraBold',
    //     value: 15,
    // },
    // {
    //     idSoft: uuidv4(),
    //     name: 'UltraLight',
    //     value: 16,
    // },
]

export default fontWeight;
